import {
	Button,
	Heading,
	Icon,
	Modal,
	ModalCloseButton,
	ModalContent,
	ModalOverlay,
	Stack,
	Text,
} from "@chakra-ui/react";
import {
	ConfirmationLayout,
	ConfirmationLayoutContent,
	ConfirmationLayoutHeader,
} from "./ConfirmationModals";
import { FaWhatsapp } from "react-icons/fa";

type JoinWhatsAppCommunityModalProps = {
	isOpen: boolean;
	onClose: () => void;
};

export default function JoinWhatsAppCommunityModal({
	isOpen,
	onClose,
}: JoinWhatsAppCommunityModalProps) {
	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
			<ModalOverlay />
			<ModalContent rounded={0} pb={6} px={4}>
				<ModalCloseButton onClick={onClose} />
				<ConfirmationLayout>
					<ConfirmationLayoutHeader />
					<ConfirmationLayoutContent>
						<Stack spacing={6}>
							<Icon
								as={FaWhatsapp}
								w={12}
								h={12}
								color={"#25D366"}
								mx={"auto"}
							/>
							<Stack>
								<Heading
									as="h2"
									size="xl"
									textAlign="center"
									fontWeight={500}
									textColor={"#153243"}
								>
									Join our WhatsApp community
								</Heading>
								<Text
									fontSize="lg"
									textAlign="center"
									fontWeight={500}
									textColor={"#5E5E5E"}
								>
									Stay connected and be the first to receive updates, exclusive
									offers, and the latest news about our products and services.
								</Text>
							</Stack>
							<Button
								w={"full"}
								colorScheme="brand"
								rounded={0}
								size="lg"
								p={{
									base: 5,
									lg: 8,
								}}
								fontWeight={500}
								onClick={() => {
									localStorage.setItem(
										"hasClickedCTAToJoinWhatsAppCommunity",
										"yes"
									);
									window.open(
										"https://whatsapp.com/channel/0029VazYhCs90x2y07cdh416",
										"_blank"
									);
								}}
							>
								Join now
							</Button>
						</Stack>
					</ConfirmationLayoutContent>
				</ConfirmationLayout>
			</ModalContent>
		</Modal>
	);
}
